import RecipeListContainer from './recipe_list_container'

export default RecipeListContainer
